import React from 'react';

/*
 * Landing page for the DocuSign JWT consent redirect
 * (DOCUSIGN_REDIRECT_URI = /docusign/callback). With JWT Grant we don't process
 * the returned ?code — consent is already recorded when the admin clicks Allow,
 * so this page just confirms success and tells them they can close the tab.
 * Registered as a public sibling route (no auth) so a fresh browser navigation
 * from DocuSign doesn't bounce to the login screen.
 */

const brand = {
  deepBlue: '#0a2947',
  tealBlue: '#0069a6',
  goldenrod: '#d09b2c',
  charcoal: '#58585b',
  softGray: '#e9e6e1',
  green: '#1a7f4e',
};

export default function DocusignCallback() {
  // If DocuSign ever redirects back with an explicit error, surface it instead
  // of a false "success" — but the common case is a granted consent.
  const params = new URLSearchParams(window.location.search);
  const error = params.get('error');
  const ok = !error;

  return (
    <div style={{
      minHeight: '100vh', background: brand.softGray,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1.5rem', fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
    }}>
      <div style={{
        background: 'white', borderRadius: 12, maxWidth: 460, width: '100%',
        boxShadow: '0 8px 40px rgba(10,41,71,0.18)', overflow: 'hidden',
      }}>
        <div style={{ background: brand.deepBlue, height: 4, width: '100%', borderBottom: `2px solid ${brand.goldenrod}` }} />
        <div style={{ padding: '2rem 1.75rem', textAlign: 'center' }}>
          <div style={{
            width: 56, height: 56, borderRadius: '50%', margin: '0 auto 1rem',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: ok ? 'rgba(26,127,78,0.12)' : 'rgba(192,57,43,0.12)',
          }}>
            <i
              className={`bi bi-${ok ? 'check-circle-fill' : 'exclamation-triangle-fill'}`}
              style={{ fontSize: '1.9rem', color: ok ? brand.green : '#c0392b' }}
            />
          </div>
          <h1 style={{ color: brand.deepBlue, fontWeight: 800, fontSize: '1.3rem', margin: '0 0 0.5rem' }}>
            {ok ? 'DocuSign consent granted' : 'Consent not completed'}
          </h1>
          <p style={{ color: brand.charcoal, fontSize: '0.9rem', margin: 0, lineHeight: 1.5 }}>
            {ok ? (
              <>The Prosperity Client Hub is now authorized to send agreements through DocuSign.
              You can close this tab.</>
            ) : (
              <>DocuSign reported: <strong>{error}</strong>. Re-open the consent link and approve the
              request, or contact your administrator.</>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
